var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"ws-page"},[_c('ws-exam-logs-list',{attrs:{"guid":_vm.guid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }